import card from "../assets/img/card.svg";

const CustomPopup = ({
  heading,
  descrText1,
  descrText2,
  handleAction,
  descrText3,
}) => {
  return (
    <div className="popUpContainer">
      <div className="popUpInner">
        <div className="popupBox whitPopBox noBorder">
          <div className="contentBox">
            <div className="doneBox" style={{ background: "none" }}>
              <img src={card} />
            </div>
            <div className="popupHeader">
              <span className="headerText">{heading}</span>
            </div>
          </div>

          <div className="contentCont">
            <span className="content1">{descrText1}</span>
            <span className="content1">{descrText3}</span>
            <span className="content2">{descrText2}</span>
          </div>

          <div className="popupBtnContainer">
            <button
              onClick={() => handleAction()}
              className="btnDone"
              style={{
                padding: "10px 61px",
                width: "100%",
                cursor: "pointer",
              }}
              type="button"
            >
              OKAY, GOT IT!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomPopup;
